var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasContent)?_c('td',[_c('span',{staticClass:"flag-icon",class:_vm.flagClass})]):_c('td',{domProps:{"innerHTML":_vm._s(_vm.nullHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }